import { render } from "./Header.vue?vue&type=template&id=f27464b2"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=f27464b2&lang=scss"

import exportComponent from "/Users/pavel/FrontReportTechnomoscow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__